import { render } from "./PTable2.vue?vue&type=template&id=46643299"
import script from "./PTable2.vue?vue&type=script&lang=js"
export * from "./PTable2.vue?vue&type=script&lang=js"

import "./PTable2.vue?vue&type=style&index=0&id=46643299&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__